import { Container } from '@mui/material';
import Page from '../../../components/Page';
import PropertyFacilityForm from './PropertyFacilityForm';

const index = () => {
  return (
    <Page title={'Property Facility'}>
      <Container maxWidth={'xl'}>
        <PropertyFacilityForm />
      </Container>
    </Page>
  );
};
export default index;
